"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toPromise = exports.toPromise = function toPromise(f) {
  return function () {
    var _arguments = arguments;

    return new Promise(function (resolve, reject) {
      var result = f.apply(null, Array.from(_arguments));
      try {
        return result.then(resolve, reject); // promise.
      } catch (e) {
        if (e instanceof TypeError) {
          resolve(result); // resolve naked value.
        } else {
          reject(e); // pass unhandled exception to caller.
        }
      }
    });
  };
};